/**
 * @module app.bdc.reports.mudetafCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function MudetafCtrl($scope, $rootScope) {
        var self = {};
        self.client = $rootScope.order.client;

        /**
         * Get the date of the day
         * @return {String}
         */
        self.getDate = function getDate() {
            return moment().format('DD/MM/YYYY');
        };

        return self;
    }

    MudetafCtrl.$inject = ['$scope', '$rootScope'];

    angular.module('app.bdc.reports.mudetafCtrl', []).controller('MudetafCtrl', MudetafCtrl);
});
